import React from 'react'

type FeatureGridSectionProps = {
  title: string
  features: string[]
}

export const FeatureGridSection: React.FC<FeatureGridSectionProps> = ({ title, features }) => {
  return (
    <section className="landing-section">
      <div className="container stack-lg">
        <div className="landing-section-heading"><h2>{title}</h2></div>
        <div className="landing-feature-grid">
          {features.map((feature) => <span key={feature}>{feature}</span>)}
        </div>
      </div>
    </section>
  )
}
